import React from "react";

const NewFiatListings = () => {
  const listings = [
    {
      title:
        "Buy ARB, ID, RDNT, TUSD & USDC Directly Using Credit/Debit Cards and Fiat Balances",
      date: "2023-04-18",
    },
    {
      title: "BADGER Available via Credit/Debit Card",
      date: "2023-01-20",
    },
    {
      title: "HOOK & MAGIC Available via Credit/Debit Card",
      date: "2022-12-30",
    },
    {
      title: "HFT, OSMO & QKC Available via Credit/Debit Card",
      date: "2022-12-02",
    },
    {
      title: "APT, POLYX & VIDT Available via Credit/Debit Card",
      date: "2022-11-18",
    },
    {
      title: "PROS & VIB Available via Credit/Debit Card",
      date: "2022-10-14",
    },
    {
      title:
        "BETH, SNM, SSV & STG Available via Credit/Debit Card, and RIF on Recurring Buy",
      date: "2022-09-09",
    },
    {
      title: "Tillionx Adds South African Rand (ZAR) Fiat Gateway",
      date: "", // The date is missing in the image for this item
    },
  ];

  return <div>
    <div className="rounded-lg shadow-sm p-6 border border-gray-200 max-w-7xl mx-auto font-sans my-16">
        <nav className="flex items-center text-sm  mb-6">
            <span className="">Announcement</span>
            <span className="mx-2">›</span>
            <span className="font-semibold text-xs">
              New Fiat Listings
            </span>
          </nav>
      {/* Header */}
      <h2 className="text-xl font-bold mb-6">New Fiat Listings</h2>

      {/* Listings List */}
      {listings.map((item, index) => (
        <div key={index} className="py-4 border-b border-gray-200 last:border-b-0">
          <h3 className="text-base font-medium leading-snug hover:underline cursor-pointer">
            {item.title}
          </h3>
          <p className="text-sm mt-1">{item.date}</p>
        </div>
      ))}
    </div>
  </div>;
};

export default NewFiatListings;
